import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import {Dimmer, Loader, Image} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import auth from "../../data/auth";
import localDB from "../../data/localDB";

const logo = require('../../img/logo_gray.svg');

class IndexSetup extends Component {

    componentDidMount() {
        localDB.set('token', this.props.match.params.session);
        auth.refresh().then(res =>{
            localDB.initialData(res);
            this.props.history.push('/account_setup')
        }).catch(()=>{
            localDB.cleanSession();
        });
    }

    render() {
        return (
            <div>
                <Helmet>
                    <title>Configuración de tu cuenta - Bisttros</title>
                </Helmet>
                <Dimmer active inverted>
                    <div style={{width: '100%'}}>
                        <Loader size='large' inline='centered'>
                            Por favor espere...
                            <br/>
                            <Image centered src={logo} height={30} alt='logo' style={{marginTop: 40}}/>
                        </Loader>
                    </div>
                </Dimmer>
            </div>
        );
    }
}

export default withRouter(IndexSetup);



// WEBPACK FOOTER //
// ./src/containers/setup/IndexSetup.js